module.exports = __webpack_public_path__ + "img/E-Commerce.7d0ffc21.svg";